module.exports = __webpack_public_path__ + "img/5d2e52ca1ae72305e6947bb9f8724600.png";